import styled from "styled-components";

export const Container = styled.div`
  left: 0px;
  bottom: 0;
  background: white;
  width: 100%;
  height: 50px;
  opacity: 0.5;
  display: none;

  @media (min-width: 426px) {
    position: fixed;
  }
`;

export const Content = styled.div`
  padding: 10px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  @media (min-width: 426px) {
    display: flex;
    padding-top: 10px;
    padding-bottom: 10px;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
  }
`;

export const Links = styled.div`
  display: inline-block;
`;
export const Link = styled.a`
  margin-right: 20px;
`;
export const HelpBtn = styled.a`
  color: #373737;
`;
